<template>
<div class="modal" tabindex="-1" id="edit-fselfletter-modal">
    <div class="modal-dialog  modal-lg">
        <div class="modal-content">
            <div class="modal-header bg-custom">
                <div class="row">
                    <p>Edit/Create your FutureSelf Letter</p>
                </div>
                <div class="row">
                    <small  style="margin-left:2em; margin-right:2em;"><strong>Instructions:</strong></b>,
                        <br/>Write <b>to</b> your FutureSelf, or <b>from</b> your FutureSelf to the You of Today
                    </small>
                    <button type="button" @click="cancel" class="close" title="Close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            </div>
            <div class="modal-body">
                <div class="row" >
                    <div class="col">
                        <h4 class="bg-secondary text-center" v-html="writeEditTitle()"></h4>
                        <div>
                                 <div style="width:80%;" class="mx-auto">
                                    <div class="row d-flex content-justify-between">
                                        <label class="modal-title my-1">Letter Title:</label>
                                        <input class="my-1 col-6" type="text" v-model="letter.title" />
                                    </div>
                                </div>
                            <div style="visibility:block;">
                                <label class="modal-title text-left">Letter Content:</label>
                                <letterInput ref="letterContent"
                                    :api-key="apikey"
                                    cloud-channel="6"
                                    :disabled=false
                                    id="visInputID"
                                    :init= "getInitMenuPlugins()"
                                    :initial-value="letter.content"
                                    :inline=false
                                    model-events= ""
                                    plugins=""
                                    tag-name="div"
                                    toolbar=""
                                    value=""
                                    name="content"
                                    v-model="letter.content"
                                />
                            </div>
                            <div class="input-container">
                                <div class="row d-flex content-justify-between">
                                    <label class="modal-title  col-8 my-1">Toggle Letter Direction:
                                    <small class="text-danger" v-if="letter.direction">(FutureSelf to Me-today)</small><small class="text-primary" v-if="!letter.direction">(Me-today to FutureSelf)</small>
                                    </label>
                                    <input ref='dir' class="my-1" type="checkbox" v-model="letter.direction" />
                                </div>
                                <div class="row d-flex content-justify-between">
                                    <label class="modal-title col-8">Visibility:
                                        <small class="text-danger"  v-if="letter.visibility">(Public)</small><small class="text-primary"  v-if="!letter.visibility">(Private)</small>
                                    </label>
                                    <input  ref='viz' class="my-1"  type="checkbox" v-model="letter.visibility" /></div>
                                <div class="row d-flex content-justify-between">
                                    <label class="modal-title col-6">Letter Date:
                                    </label>
                                    <input   class="my-1"  type="date" v-model="letter.at_date" /></div>
                                <div class="row d-flex content-justify-between">
                                    <label class="modal-title col-6">Notify Me In (years):</label>
                                    <input  class="my-1"  style="width:80px;" type="number" min='2' max='20' v-model="letter.deliver_in" />
                                </div>
                            </div>

                            <button class="btn btn-sm btn-warning float-right mx-2 my-2" @click="cancel">Close</button>
<!-- v-if="isLetterSavable()"  :disabled="!isLetterSavable()" v-if="letter.title!='' && letter.content.length>30 && (letter.at_date > new Date())"-->
                            <button  class="btn btn-sm btn-primary float-right  mx-2 my-2"  @click="saveAction">Save</button>
                        </div>
                    </div>

<!-- {{this.$refs.vizInp.value}} {{this.$refs.planInp.value}} {{this.$refs.mezInp.value}} -->
                </div>
<small v-if="!isNewLetter" >Letter created at: {{letterData.created_at}}</small>
<!-- <small >Letter savable: {{ isLetterSavable()}}</small> -->
            </div>
        </div>

    </div>

</div>

</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import EventBus from '../../../event-bus';
import Editor from '@tinymce/tinymce-vue';
 //direction options: true: from me to futureme, false: from futureme to me.
//deliver_in number of years from created_at date to email the user;
//at_date is the date that that letter is dated (from futureme or to futureme for that date)

import { v4 as uuidv4 } from 'uuid';

export default {
    components: {
    letterInput: Editor,
     },
    name: "FutureSelfLetter",
    data() {
        return {
            csrf_token: document.head.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            userinfo:'',
            letterData: [],
            isNewLetter:false,
            letter:{visibility:false,
                    direction:false,
                    content:'',
                    title:'',
                    at_date: new Date(),
                    },
        }
    },

    props: {
        userdata:'',
        letters:[],
        apikey:'',
    },
    mounted() {
        this.userinfo = JSON.parse(this.userdata);

        EventBus.$on('displayLetterModal', (data) => {
            console.log("displayLetterModal triggered..." + data);
            this.modalReset();
            this.letterData = data.letter;
            if(this.letterData && this.letterData.id != '') this.isNewLetter = false;
            // this.letter.id = this.letterData.id;
            // this.letter.title = this.letterData.title;
            // this.letter.content = this.letterData.content;
            // this.letter.visibility = this.letterData.visibility;
            // this.letter.at_date = this.letterData.at_date;
            // this.letter.deliver_in = this.letterData.deliver_in;
            // this.letter.direction = this.letterData.direction;
                this.letter = {...this.letterData};
            $('div#edit-fselfletter-modal').modal('show');
        });
        EventBus.$on('newLetterModal', (data) => {
            this.isNewLetter = true;
            this.letter.id = '';
            this.letter.title = '';
            this.letter.content ='';
            this.letter.at_date = '';
            this.letter.deliver_in = 0;
            // this.letter.visibility = false; //Leave uncommented, so messages toggle trigger (TO FIND OUT WHY WON'T WORK IF SET)
            // this.letter.direction = false;  //Leave uncommented, so messages toggle trigger (TO FIND OUT WHY WON'T WORK IF SET)
            $('div#edit-fselfletter-modal').modal('show');
        });

        // this.$watch(this.letter =[this.letter.visibility, this.letter.direction],{immediate:true, deep:true});

    },


    methods: {
        // isLetterSavable() {
        // return (this.isEditable()||this.isNewLetter) && this.letter.title != '' && this.letter.content.length > 120 && this.letter.at_date;

        // },
        writeEditTitle() {
            return (this.isNewLetter)? "Create a New Letter": "Edit Letter";
        },
        isEditable() {
            var d = new Date();
            var twoDaysAgo = d.getDate()-2;
            // console.log(twoDaysAgo);
            return this.isNewLetter || this.letterData.created_at < twoDaysAgo;//only editable for 48 hours after first creation.

        },
         getGUID() {
            var guid = uuidv4();
            // console.log("GUID: " + guid);
            return guid;
        },
        modalReset() {
            //set all fields to blank
        },
        cancel() {
            // console.log("Cancel close FutureSelfLetter");
            this.letter = {};
            $('div#edit-fselfletter-modal').modal('hide');
            EventBus.$emit('refreshParentPage');
            // location.reload();
        },
        getInitMenuPlugins() {
            return {
                height: 330,
                menubar: false,
                plugins: [
                    'code table lists'
                ],
                toolbar:
                    'undo redo | formatselect | bold italic backcolor | \
                    alignleft aligncenter alignright alignjustify | \
                    bullist numlist outdent indent | removeformat | help'
            }
        },
        saveAction() {
            //console.log(this.$refs.vizInp.value);
            // console.log(this.$refs.planInp.value);
            // console.log(this.$refs.mezInp.value);
            this.saveDetails();
        },

        saveDetails() {
            // bugfix:  cannot set visiblity or direction for a new letter.
            //ensure both are one or the other if they're null
            if(!this.letter.visibility) this.letter.visibility = false;//private.
            if(!this.letter.direction) this.letter.direction = false; //me to future self
            axios.post('/comms/saveupdate', {

                user_id: this.userinfo.id,
                letter_id: this.letter.id,
                title: this.letter.title,
                content: this.letter.content,
                visibility: this.letter.visibility,
                direction: this.letter.direction,
                deliver_in: this.letter.deliver_in,
                at_date: this.letter.at_date
            })
            .then(res => {
                this.message = res.data.message;
                res.data.letter? this.letterData = JSON.parse(res.data.letter):'';
                res.data.letter? this.letter = JSON.parse(res.data.letter):'';

                this.isNewLetter = false;//now flag as an old letter after having refreshed the letter after a save.
                this.updateToast(this.message, 4000);
                console.error(res.data.message);
            })
            .catch(err => {
                this.updateToast(err.message, 4000, 'error');
                console.error(err.message);

            })
            .finally(()=> {
                // location.reload();
            });
            EventBus.$emit('refreshAfterLetterSave');

        },
        updateToast(message, timer = 2000, icon='success') {
            const Toast = Swal.mixin({
                position: 'center',
                width: 500,
                showConfirmButton: true,
            });
            Toast.fire({
                icon: icon,
                title: message
            });
        },

    },
    computed: {
    },
}
</script>
<style>
    .bg-custom{
        background: #449acb;
    color: #fff;
    }
    .input-container{
        max-width:80%;
        margin:auto;
        /* @media (max-width: 768px) {
            min-width: 80%;
        } */
@media only screen
    and (device-width: 375px)
    and (device-height: 812px)
    and (-webkit-device-pixel-ratio: 3) {
        width:90%;
     }
    }
</style>
